import { useCallback } from 'react';
import { ProductType } from '@/data/types/Product';
import { findParentCategories } from 'shared/custom/utils/getCategoryByIdForGA';
import { GiftType } from 'presentation/events/constants/eventConstants';
import { useTrackSelectItem } from 'presentation/events/hooks/useTrackSelectItem';
import { useGetCategories } from 'shared/custom/hooks/Categories';

export const useOnTrackSelectItem = ({
	product,
	isEmarsys,
	promoThdCode,
	giftType,
	plpBadges,
}: {
	product: ProductType | undefined;
	isEmarsys?: boolean;
	promoThdCode?: string;
	giftType?: GiftType;
	plpBadges?: string;
}) => {
	const { navigation } = useGetCategories();

	const trackSelectItem = useTrackSelectItem();

	return useCallback(() => {
		if (!product) return;

		const categories = product.parentCatalogGroupID
			? findParentCategories(navigation, product.parentCatalogGroupID)
			: [];

		trackSelectItem({
			product: { ...product, promoThdCode, ...(giftType ? { giftType } : {}) },
			isEmarsys,
			categories,
			plpBadges,
		});
	}, [product, navigation, trackSelectItem, isEmarsys, promoThdCode, giftType, plpBadges]);
};
